import React from "react";
import { withRouter } from "react-router";
import { parseCategoryID } from "../../utils/index";
import get from "lodash.get";
import { useTranslation } from "react-i18next";

import "moment/locale/en-gb";
import "moment/locale/zh-cn";
import "moment/locale/ja";
import "moment/locale/ko";
import "moment/locale/th";

function SerieItem(props) {
  const { data } = props;
  const { t } = useTranslation();

  const toSeries = () => {
    props.history.push(`/series/${data?.id}`);
  };

  return (
    <div className="serie-item">
      <div
        className="inner"
        style={{
          backgroundImage: `url(${
            process.env.REACT_APP_IMG_URL
          }/storage/serie-picture/${get(
            data,
            "seriePicture.uri",
            ""
          )}?format=Horizontal_Center`,
        }}
        >
        <div className="content">
          <div
            className={`cat ${parseCategoryID(get(data, "category", "")).categoryShorthand
              }`}
          >
            {t(
              parseCategoryID(get(data, "category", ""))
                ?.categoryTranslationKey
            )}
          </div>
          <div className="title">{get(data, "title", "")}</div>
          <div className="speaker-name">
            {t("Speakers")}: {get(data, "speakers", [])
              .filter((spkr) => spkr !== null)
              .map((spkr, i) => `${spkr.name} ${spkr.surname}`).join(", ")}
          </div>
          <div className="progress">{get(data, "completedEpisodeCount", 0)}/{get(data, "totalEpisodeCount", 0)} {t("home_series_progress")}</div>
          <div className="progress-bar">
            <div className="progress-fill" style={{ width: `${get(data, "completionPercent", 0)}%` }}></div>
          </div>
          <div className="button" onClick={toSeries}>
            {get(data, "ctaType", "") === "start" && t("start_series")}
            {get(data, "ctaType", "") === "continue" && t("continue_series")}
            {get(data, "ctaType", "") === "watch_again" && t("review_series")}
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(SerieItem);
